import { TClientPlatform } from 'models/analytics'

export const platformLabels: Record<TClientPlatform, string> = {
  web_desktop: 'Сайт (desktop)',
  web_mobile: 'Сайт (mobile)',
  web: 'Сайт (не определено)',
  ios: 'Приложение iOS',
  android: 'Приложение Android'
}

export const platformColors: Record<TClientPlatform, string> = {
  web_desktop: 'blue',
  web_mobile: 'blue',
  web: 'blue',
  ios: 'purple',
  android: 'green'
}
